module.exports = __webpack_public_path__ + "static/media/folderOpen.6913563c.svg";